import { ReactComponent as ContactIconSVG } from "./contact.svg";
import { SvgIcon } from '@mui/material';

export default function IconContact(props) {
  return <SvgIcon {...props} component={ContactIconSVG} viewBox="0 0 18 18" />;
}